import type { AxiosInstance } from 'axios';

export interface CommissionRule {
  id: string;
  scope: 'GLOBAL' | 'CATEGORY' | 'VENDOR';
  categoryId?: string | null;
  vendorId?: string | null;
  bps: number;
  effectiveFrom: string;
  effectiveTo?: string | null;
  category?: { id: string; name: string };
  vendor?: { id: string; storeName: string };
}

export interface CommissionRuleListResponse {
  data: CommissionRule[];
  page: { page: number; pageSize: number; total: number; pageCount: number };
}

export interface CreateCommissionRuleInput {
  scope: 'GLOBAL' | 'CATEGORY' | 'VENDOR';
  categoryId?: string;
  vendorId?: string;
  bps: number;
  effectiveFrom?: string;
  effectiveTo?: string;
}

export interface UpdateCommissionRuleInput {
  bps?: number;
  effectiveTo?: string;
}

export function commissionsEndpoints(http: AxiosInstance) {
  return {
    listRules: (params?: { page?: number; pageSize?: number }) =>
      http.get<CommissionRuleListResponse>('/admin/commissions/rules', { params }).then((r) => r.data),

    createRule: (data: CreateCommissionRuleInput) =>
      http.post<CommissionRule>('/admin/commissions/rules', data).then((r) => r.data),

    updateRule: (ruleId: string, data: UpdateCommissionRuleInput) =>
      http.patch<CommissionRule>(`/admin/commissions/rules/${ruleId}`, data).then((r) => r.data),

    deleteRule: (ruleId: string) =>
      http.delete(`/admin/commissions/rules/${ruleId}`).then((r) => r.data),
  };
}

export type CommissionEndpoints = ReturnType<typeof commissionsEndpoints>;
